var exports = {
  "kL": "xa15a2ab7--3971a8--container",
  "wx": "xa15a2ab7--3971a8--header",
};

module.exports = exports;
